import {BitrixVue} from 'ui.vue'

BitrixVue.component('ResultBlockBottom', {
  props: ['totalAmount'],
  template: `
    <div class="result-block__bottom">
        <div class="result-block__text">Итого</div>
        <div class="result-block__total">{{new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(totalAmount)}}</div>
    </div>
`,
})
